/** One cash-basis rule for dashboards, reports and filtered movement totals. */
export type FinancialMovement = {
  status?: string | null
  valor_realizado?: number | null
  valor_previsto?: number | null
  data_realizacao?: string | null
  vencimento?: string | null
  competencia?: string | null
}
export const isSettled = (status?: string | null) => ['PAGO','RECEBIDO','REALIZADA'].includes(String(status || '').toUpperCase())
export const isExcluded = (status?: string | null) => ['CANCELADO','CANCELADA','ESTORNADO','ESTORNADA'].includes(String(status || '').toUpperCase())
export const cashDate = (row: FinancialMovement) => String(row.data_realizacao || row.vencimento || row.competencia || '').slice(0,10)
export const movementValue = (row: FinancialMovement) => Number(isExcluded(row.status) ? 0 : isSettled(row.status) ? row.valor_realizado ?? row.valor_previsto ?? 0 : row.valor_previsto ?? 0)
export const sumMoney = (values: number[]) => values.reduce((cents,value) => cents + Math.round((value + Number.EPSILON) * 100),0) / 100

/** Reversing a settlement clears all settlement fields, including its status. */
export function settlementFields(form: {
  tipo: string; realizado?: boolean; status?: string; valor_previsto: number
  valor_realizado?: number; data_realizacao?: string | null; vencimento?: string | null
  conta_realizada_id?: string | null; conta_prevista_id?: string | null
}) {
  if (!form.realizado) return {status: form.status === 'CANCELADO' ? 'CANCELADO' : 'PENDENTE', valor_realizado:0, data_realizacao:null, conta_realizada_id:null}
  const valor=Number(form.valor_realizado ?? form.valor_previsto)
  const conta=form.conta_realizada_id || form.conta_prevista_id
  const data=form.data_realizacao || form.vencimento
  if (!Number.isFinite(valor) || valor <= 0) throw new Error('Informe um valor realizado maior que zero.')
  if (!conta) throw new Error('Selecione a conta da realização.')
  if (!data) throw new Error('Informe a data da realização.')
  return {status:form.tipo === 'RECEITA' ? 'RECEBIDO' : 'PAGO', valor_realizado:Math.abs(valor), data_realizacao:data, conta_realizada_id:conta}
}
